export const MIN_SCALE = 0.4;
export const MAX_SCALE = 3.0;
export const SCALE_STEP = 0.2;
